<template>
  <div class="section-details">
    <div class="title">{{title}}</div>
    <EditionArticle v-for="(article, index) in articles" :article="article" :key="index" />
  </div>
</template>

<script>
import EditionArticle from './EditionArticle.vue'
export default {
  name: 'SectionDetails',
  props: ['section'],
  components: {
      EditionArticle
  },
  data () {
    return {
    }
  },
  computed: {
    title () {
      return this.section.title
    },
    articles () {
      return this.section.articles
    }
  }
}
</script>

<style scoped lang="scss">
.section-details {
  padding-top: 10px;
}
.title {
  font-size: 24px;
  font-weight: 600;
  padding-bottom: 5px;
}
</style>
